<template>
  <div class="ellipsis" :style="{'margin-left': align ? '-10px' : '0' }" v-if="taskConfig.names.length !== 0">
    <div v-if="config">
      <v-tooltip v-for="(code, i) in taskCodes" :key="`task-${code}`" bottom>
        <template v-slot:activator="{ on }">
          <v-chip class="mx-1" v-on="on" :dark="dark">
            {{ code }}
          </v-chip>
        </template>
        <template>
          <div v-for="(value, key) in taskParameters(i)" :key="`${code}-${key}`">
              {{ key }}: {{ value }}
          </div>
        </template>
      </v-tooltip>
    </div>
  </div>
  <div v-else>
    <em>No tasks</em>
  </div>
</template>

<script>
import { config } from '@/helpers'

export default {
  name: 'TaskConfigSummary',
  props: {
    /**
     *  The list of tasks to be displayed
     */
    taskConfig: Object,
    /**
     *  If true, apply Vuetify's dark style on the chip
     */
    dark: {
      type: Boolean,
      default: false
    },
    /**
     *  If true, the chips will be slightly pulled left to align with text in other rows
     */
    align: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      config: config
    }
  },
  computed: {
    taskCodes () {
      return this.taskConfig.names.map((name) => {
        if (this.$store.getters['tasks/taskTypeByName'](name)) {
          return this.$store.getters['tasks/taskTypeByName'](name).short_code
        }
      })
    }
  },
  methods: {
    taskParameters (index) {
      let taskName = this.taskConfig.names[index]
      let taskType = this.$store.getters['tasks/taskTypeByName'](taskName)
      let parameters = this.taskConfig.parameters[taskName]
      let result = {}
      for (let key in parameters) {
        let value = parameters[key]
        let properties = this.taskProperty(taskType, key)

        if (!(key in parameters) || (parameters[key] == null)) {
          value = 'random'
        } else if ('oneOf' in properties) {
          for (let oneOf of properties.oneOf) {
            if (oneOf.const === parameters[key]) {
              value = oneOf.description
            }
          }
        }

        result[key] = value
      }

      return result
    },

    taskProperty (taskType, propertyName) {
      if (taskType && 'properties' in taskType.json_schema && propertyName in taskType.json_schema.properties) {
        return taskType.json_schema.properties[propertyName]
      }
      return {}
    }
  }
}
</script>
